import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { MEDIA_GALLERY_SKELETON_COUNT } from 'src/views/OmniChannel/constants/mediaGallery';

export const MediaGallerySkeleton = ({
    variant = 'grid',
}: {
    variant?: 'grid' | 'list';
}) => {
    if (variant === 'list') {
        return (
            <Box display="flex" flexDirection="column" gridGap={8}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <Box
                        key={index}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '12px 14px',
                            borderRadius: 8,
                        }}
                    >
                        <Skeleton
                            variant="rect"
                            width={40}
                            height={40}
                            animation="wave"
                            style={{ borderRadius: 8 }}
                        />
                        <Box flex={1}>
                            <Skeleton variant="text" width="70%" animation="wave" />
                            <Skeleton variant="text" width="40%" animation="wave" />
                        </Box>
                        <Skeleton variant="circle" width={32} height={32} animation="wave" />
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Grid container spacing={2}>
            {Array.from({ length: MEDIA_GALLERY_SKELETON_COUNT }).map((_, index) => (
                <Grid item xs={6} sm={4} md={3} key={index}>
                    <Skeleton
                        variant="rect"
                        height={160}
                        animation="wave"
                        style={{ borderRadius: 8, width: '100%' }}
                    />
                </Grid>
            ))}
        </Grid>
    );
};
